import { ButtonBase, Grid, Paper, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { MilanTimezoneAwareClock } from "../timezone_aware_clock";

const values = [6, 7, 8, 9, 10, 11, 12];

const formatTime = (t: number) => {
  const offset = new Date().getTimezoneOffset();
  // console.log("offset is", offset);
  const tWithOffset = t - offset / 60;

  return `${tWithOffset.toString().padStart(2, "0")}:00`;
};

export type TimezoneAwareTimePickerProps = {
  value?: number;
  onChange: (v: number) => void;
  tz?: string;
};
export default function TimezoneAwareTimePicker(
  props: TimezoneAwareTimePickerProps
) {
  const { value, onChange } = props;

  const {
    palette: { primary: primaryColor },
  } = useTheme();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h4">
          Orario di cutoff per l'accettazione in giornata di un ritiro
        </Typography>
        <Typography variant="caption">
          S&apos;intende l&apos;orario limite entro il quale un ordine viene
          ritirato in giornata, riferito al fuso orario italiano. Ora attuale in
          Italia: <MilanTimezoneAwareClock />
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
      >
        {values.map((utcHour) => (
          <Paper
            component={ButtonBase}
            onClick={() => onChange(utcHour)}
            square
            elevation={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              height: 50,
              width: 50,
              border: value === utcHour ? "1px solid " + primaryColor.main : "",
            }}
          >
            {formatTime(utcHour)}
          </Paper>
        ))}
      </Grid>
    </Grid>
  );
}
